import { AppState } from 'mk2/reducers';
import {
    initialGroupSubscribedFeedPageState,
    initialGroupSubscribedFeedState,
    initialGroupSubscribedFeedVirtualPageState,
    initialPostsState,
    GroupSubscribedFeedPageState,
    GroupSubscribedFeedVirtualPageState,
    OrderBy,
} from './GroupSubscribedFeed.reducers';

export const getGroupSubscribedFeedState = (state: AppState) => {
    if (!state.containers.groups.groupSubscribedFeed) {
        return initialGroupSubscribedFeedState;
    }

    return state.containers.groups.groupSubscribedFeed;
};

export const getGroupSubscribedFeedSearchState = (state: AppState, orderBy: OrderBy) => {
    const groupSubscribedFeedState = getGroupSubscribedFeedState(state);

    if (!groupSubscribedFeedState.orders[orderBy]) {
        return initialPostsState;
    }

    return groupSubscribedFeedState.orders[orderBy];
};

export const getGroupSubscribedFeedPageState = (state: AppState, orderBy: OrderBy, page: number): GroupSubscribedFeedPageState => (
    getGroupSubscribedFeedSearchState(state, orderBy).pages[page] || initialGroupSubscribedFeedPageState
);
export const getGroupSubscribedFeedVirtualPageState = (state: AppState, orderBy: OrderBy, pageName: string): GroupSubscribedFeedVirtualPageState => (
    getGroupSubscribedFeedSearchState(state, orderBy).virtualPages[pageName] || initialGroupSubscribedFeedVirtualPageState
);
